var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.rowList),function(item,index){return _c('div',{key:index,staticClass:"view-row"},_vm._l((item),function(i,idx){return _c('div',{key:idx,staticClass:"view-field"},[_c('div',{staticClass:"view-label"},[_vm._v(_vm._s(i.lable))]),_c('div',{staticClass:"view-value"},[_vm._v(_vm._s(i.value))])])}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }